import { useState } from "react";
import "./addition.css";

export default function AdditionConfig({ onStart }) {
  const [modalType, setModalType] = useState(null);

const [digitSize, setDigitSize] = useState("Single");
const [numDigits, setNumDigits] = useState(6);
const [speed, setSpeed] = useState(600);
const [waitTime, setWaitTime] = useState(600);


  return (
    <div className="addition-container">

      <div className="config-card">

        <div className="config-title">Addition</div>

        <div className="row clickable" onClick={() => setModalType("digit")}>
          <span>Digit Size</span>
          <span>{digitSize} ▼</span>
        </div>

        <div className="row clickable" onClick={() => setModalType("count")}>
          <span>No. of digits</span>
          <span>{numDigits} ▼</span>
        </div>

        <div className="row">
          <span>Flickering Speed</span>

          <div className="speed-control">
            <button
              onClick={() => setSpeed(Math.max(200, speed - 100))}
              className="speed-btn minus"
            >
              -
            </button>

            <span className="speed-value">{speed} ms</span>

            <button
              onClick={() => setSpeed(Math.min(999, speed + 100))}
              className="speed-btn plus"
            >
              +
            </button>
          </div>
        </div>

        <div className="row">
          <span>Wait Time</span>

          <div className="speed-control">
            <button
              onClick={() => setWaitTime(Math.max(200, waitTime - 100))}
              className="speed-btn minus"
            >
              -
            </button>

            <span className="speed-value">{waitTime} ms</span>

            <button
              onClick={() => setWaitTime(Math.min(999, waitTime + 100))}
              className="speed-btn plus"
            >
              +
            </button>
          </div>
        </div>

      </div>

      <div className="button-group">
        <button
          className="btn-primary"
          onClick={() =>
            onStart({
              digitSize,
              numDigits,
              speed,
              waitTime,
            })
          }
        >
          Start
        </button>
      </div>

    {/*  ADD MODAL HERE  */}

    {modalType && (
      <div className="modal-overlay">
        <div className="modal">

          <div className="modal-header">
            {modalType === "digit" && (
              <>
                <strong>Digit Size</strong>
                <p>Option to select</p>
              </>
            )}

            {modalType === "count" && (
              <>
                <strong>No. of digits</strong>
                <p>Option to select</p>
              </>
            )}
          </div>

          <div className="modal-options">

            {/* Digit Options */}
            {modalType === "digit" &&
              ["Single", "Double", "Triple", "Quad"].map((item) => (
                <div
                  key={item}
                  className={`option ${digitSize === item ? "selected" : ""}`}
                  onClick={() => {
                    setDigitSize(item);
                    setModalType(null);
                  }}
                >
                  {item}
                </div>
              ))}

            {/* Count Options */}
            {modalType === "count" &&
              Array.from({ length: 24 }, (_, i) => i + 2).map((num) => (
                <div
                  key={num}
                  className={`option ${numDigits === num ? "selected" : ""}`}
                  onClick={() => {
                    setNumDigits(num);
                    setModalType(null);
                  }}
                >
                  {num}
                </div>
              ))}

          </div>

          <div className="cancel" onClick={() => setModalType(null)}>
            Cancel
          </div>

        </div>
      </div>
    )}

  </div>
);
}